/**
 * Returns the EnvelopeType string for a given EnvelopeCode.
 *
 * @param code EnvelopeCode ('B', 'S', 'C')
 * @returns EnvelopeType ('blank', 'return', 'return-recipient')
 */
import { EnvelopeCode, EnvelopeType } from '../../global-types/envelope';

export const getEnvelopeTypeByCode = (code: EnvelopeCode): EnvelopeType => {
  switch (code) {
    case EnvelopeCode.Blank:
      return EnvelopeType.Blank;
    case EnvelopeCode.Return:
      return EnvelopeType.Return;
    case EnvelopeCode.ReturnRecipient:
      return EnvelopeType.ReturnRecipient;
    default:
      throw new Error(`Error getting envelope type for code: ${code}`);
  }
};
